import { Component, OnInit, Input, Inject, signal, OnChanges } from '@angular/core';
import {
  DateOptions,
  DATE_OPTIONS,
  ProcessProviderId,
  WalletDisplayTypeId,
  MarketplaceWalletItem,
  MarketplaceService,
  RewardsWalletQuery,
  MarketplaceItemAttributeDisplayType,
} from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { DateTime } from 'luxon';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-marketplace-purchased-list-item',
  templateUrl: './marketplace-purchased-list-item.component.html',
  styleUrls: ['./marketplace-purchased-list-item.component.scss'],
})
export class MarketplacePurchasedListItemComponent implements OnInit, OnChanges {
  @Input() purchaseItem: MarketplaceWalletItem;
  @Input() multi: boolean;
  @Input() showButton: boolean = true;
  @Input() orientation: 'landscape' | 'portrait' = 'portrait';
  @Input() redeemed: boolean = false;
  ProcessProvider = ProcessProviderId;
  WalletDisplayType = WalletDisplayTypeId;
  screenType = ScreenType;
  groupItem$: Observable<any>;
  attributeDisplayType = MarketplaceItemAttributeDisplayType;
  expired = signal(false);

  constructor(
    @Inject(DATE_OPTIONS) public dateOption: DateOptions,
    private marketplaceService: MarketplaceService,
    private rewardsWalletQuery: RewardsWalletQuery
  ) {}

  ngOnInit() {
    this.groupItem$ = this.rewardsWalletQuery.selectItemsByGroupId(this.purchaseItem.GroupId);
  }

  ngOnChanges(): void {
    const isExpired = DateTime.fromISO(this.purchaseItem.ExpireDate as string, { zone: 'utc' }) < DateTime.utc();
    this.expired.set(isExpired);
  }

  downloadPurchasedItem(logId: number) {
    firstValueFrom(this.marketplaceService.downloadMarketplaceItem(logId)).then((response) => {
      const newBlob = new Blob([response], { type: response.type });
      const objectUrl = window.URL.createObjectURL(newBlob);
      const anchor = window.document.createElement('a');
      anchor.href = objectUrl;
      // TODO: Return marketplace item download name
      anchor.download = logId.toString();
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 100);
    });
  }

  copyToClipboard(code: string) {
    navigator.clipboard.writeText(code);
  }

  get isUniqueCodeLink() {
    return this.purchaseItem.Code.toString().includes('http://') || this.purchaseItem.Code.toString().includes('https://');
  }
}
